export const SIZE = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};
export const TYPE = {
  DEFAULT: 'default',
  INITIAL: 'initial',
  IMAGE: 'image',
  ICON: 'icon'
};